class NavigationService {
  navigate: ((path: string) => void) | null = null;

  setNavigate(fn: (path: string) => void) {
    this.navigate = fn;
  }

  go(path: string) {
    if (!this.navigate) throw new Error('navigate() not set');
    this.navigate(path);
  }
}

export const navigationService = new NavigationService();
